import React from "react";
import { Box, Typography } from "@mui/material";
import { useEditorialSectionStyles } from "./EditorialSection.styles";
import Reveal from "../../../ui/Reveal";
import SectionEyebrow from "../../../ui/SectionEyebrow";
import { unsplashImageUrl } from "../../../../utils/unsplashImage";

interface EditorialSectionProps {
    variant: "image" | "typographic";
    eyebrow: string;
    title: string;
    body: string;
    imagePhotoId?: string;
    imageFirst?: boolean;
}

const EditorialSection = (props: EditorialSectionProps) => {
    const { classes } = useEditorialSectionStyles();

    if (props.variant === "typographic") {
        return (
            <Box className={classes.typographicRoot}>
                <Reveal>
                    <Box className={classes.typographicInner}>
                        <SectionEyebrow label={props.eyebrow} />
                        <Typography variant="display2" className={classes.typographicTitle}>
                            {props.title}
                        </Typography>
                        <Typography variant="body1" className={classes.typographicBody}>
                            {props.body}
                        </Typography>
                    </Box>
                </Reveal>
            </Box>
        );
    }

    return (
        <Box className={classes.imageRoot}>
            <Box
                className={classes.imageLayout}
                sx={props.imageFirst ? undefined : { "& > *:first-of-type": { order: { md: 2 } } }}
            >
                <Box className={classes.imageWrapper}>
                    <Box
                        component="img"
                        src={unsplashImageUrl(props.imagePhotoId ?? "photo-1609081144289-eacc3108cd03", 1200, 1400)}
                        alt=""
                        className={classes.image}
                    />
                </Box>
                <Box className={classes.textWrapper}>
                    <Reveal>
                        <SectionEyebrow label={props.eyebrow} />
                        <Typography variant="h2" className={classes.title}>
                            {props.title}
                        </Typography>
                        <Typography variant="body1" className={classes.body}>
                            {props.body}
                        </Typography>
                    </Reveal>
                </Box>
            </Box>
        </Box>
    );
};

export default EditorialSection;
